import {
  JuridictionAdminResponseDto,
  JuridictionAdminResponseDtoTypeEnum,
  JuridictionRequestDto,
  JuridictionRequestDtoTypeEnum,
  JuridictionResponseDto,
} from 'lib_api/lib/api/gen';

import { getOptionValueAsStringOrNull } from 'typeGuards/typeGuards';
import { ShouldNotHappen } from 'utils/exceptions';

import { JuridictionFormValue } from '../types';

export function buildDto(values: JuridictionFormValue): JuridictionRequestDto {
  return {
    codePostal: values.codePostal ?? null,
    idCorrelationJuridictionParent: getOptionValueAsStringOrNull(
      values.juridictionParente,
    ),
    libelle: values.libelle ?? null,
    numero: values.numero ?? null,
    origineElement: values.origineElement ?? null,
    type: values.type ?? null,
  };
}

function mapJuridictionTypeEnum(
  type: JuridictionAdminResponseDtoTypeEnum,
): JuridictionRequestDtoTypeEnum {
  switch (type) {
    case JuridictionAdminResponseDtoTypeEnum.COUR_APPEL:
      return JuridictionRequestDtoTypeEnum.COUR_APPEL;
    case JuridictionAdminResponseDtoTypeEnum.TRIBUNAL_JUDICIAIRE:
      return JuridictionRequestDtoTypeEnum.TRIBUNAL_JUDICIAIRE;
    default:
      throw new ShouldNotHappen(type);
  }
}

export function buildDefaultUpdateFormValues(
  juridiction: JuridictionAdminResponseDto,
  juridictionParente?: JuridictionResponseDto,
): JuridictionFormValue {
  const juridictionParenteOption = juridictionParente
    ? {
        value: juridictionParente.idCorrelation,
        label: juridictionParente.libelle,
        option: juridictionParente,
      }
    : undefined;
  return {
    codePostal: juridiction.codePostal ?? undefined,
    juridictionParente: juridictionParenteOption,
    libelle: juridiction.libelle ?? undefined,
    numero: juridiction.numero ?? undefined,
    origineElement: juridiction.origineElement ?? undefined,
    type: juridiction.type
      ? mapJuridictionTypeEnum(juridiction.type)
      : undefined,
  };
}
